<!-- 组队瓜分奖品 -->
<template>
  <div class="createPlayStep new-input-box">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-back
        @back="returnBack()"
        :title="['互动广场']"
        :subTitle="activityData.name"
        style="padding-bottom: 0"
      ></jd-back>
    </div>
    <div class="formBox">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 活动条件表单设置 -->
      <div class="secondstep" v-if="localStepNum == 0 || localStepNum == 1">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          class="backgroundForm"
          label-width="150px"
          v-loading="loading"
        >
          <informationForm
            @selectPeopleSure="selectPeopleSure"
            @getMemberFn="getMemberFn"
            :defaultActMember.sync="actMember"
            :defaultActivityStartTime="activityStartTime"
            :defaultActivityEndTime="activityEndTime"
            :plusObject.sync="ruleDTO.plusObject"
            :openCardStartTime.sync="ruleDTO.openCardStartTime"
            :openCardEndTime.sync="ruleDTO.openCardEndTime"
            :peopleSelected.sync="peopleSelected"
            ref="informationForm"
            v-model="ruleForm"
            :isEdit="false"
            :disabled="activityData.isStart"
            :localStepNum="localStepNum"
            :needNonMember="false"
            :activityId="70"
            :showOpenCardTip="true"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          >
          </informationForm>
          <jd-title label="竞拍规则设置"></jd-title>
          <div class="mt20">
            <!-- 奖品 -->
            <el-form-item label="奖品设置：" required>
                  <div style="max-width: 1300px">
                      <jd-table :tableData="tableData">
                        <el-table-column label="奖品类型">
                          <template slot-scope="scope">
                            <span>{{
                              getPrizeTypeName(scope.row.prizeType)
                            }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="值"
                          width="100"
                          prop="price"
                        ></el-table-column>
                        <el-table-column label="奖品名称（12字内）" width="270">
                          <template slot="header">
                            <span style="color: red">*</span>奖品名称（12字内）
                          </template>
                          <template slot-scope="scope">
                            <el-input
                              v-model="scope.row.title"
                              maxlength="12"
                              :disabled="
                                scope.row.prizeType != 3 ||
                                scope.row.isGoodManage
                              "
                              show-word-limit
                              style="width: 230px"
                              placeholder="请输入"
                            ></el-input>
                          </template>
                        </el-table-column>
                        <el-table-column label="奖品数量" width="150">
                          <template slot="header">
                            <span style="color: red">*</span>奖品数量
                          </template>
                          <template slot-scope="scope">
                            <el-input
                              v-model.number="scope.row.totalAmount"
                              @input.native="
                                (e) =>
                                  (scope.row.totalAmount = checkputn(
                                    e,
                                    scope.row
                                  ))
                              "
                              placeholder="请输入"
                              @input="
                                (scope.row.totalAmount = getNumberData(
                                  1,
                                  $event,
                                  0,
                                  1,
                                  999999
                                )),
                                  prizeNum(scope.row)
                              "
                              @blur="beAdd(scope.row)"
                              :disabled="
                                (activityData.isStart && !scope.row.minNum) ||
                                activityData.isStart ||
                                activityData.backgroundOpacity
                              "
                            ></el-input>
                          </template>
                        </el-table-column>
                        <el-table-column label="图片" width="150">
                          <template slot-scope="scope">
                            <img
                              v-if="scope.row.logo"
                              :src="scope.row.logo"
                              style="width: 56px; height: 56px"
                            />
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="剩余库存"
                          width="180"
                          v-if="activityData.isStart"
                        >
                          <template slot-scope="scope">
                            <el-input
                              v-model="scope.row.remanentAmount"
                              style="width: 80px"
                              disabled
                            ></el-input>
                            份
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="操作"
                          fixed="right"
                          min-width="180"
                          align="center"
                        >
                          <template slot-scope="scope">
                            <jd-button
                              type="blueText"
                              :disabled="
                                activityData.backgroundOpacity || activityData.isStart
                              "
                              @click="centerVis(scope, 0)"
                              >选择奖品</jd-button
                            >
                            <jd-button
                              type="blueText"
                              v-if="activityData.isStart && !activityData.backgroundOpacity"
                              @click="addStock(scope, 0)"
                              >增加库存</jd-button
                            >
                          </template>
                        </el-table-column>
                      </jd-table>
                      <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
                 </div>
              </el-form-item>
              <el-form-item label="竞拍门票：">
                <el-input
                  v-model="ruleForm.ticket"
                  class="w90"
                  placeholder="请输入"
                  @input="
                    ruleForm.ticket = getNumberData(
                      1,
                      $event,
                      0,
                      1,
                      999999,
                    )
                  "
                ></el-input>
                <span class="ml8">积分</span>
                <span class="tip-color">
                  （仅支持输入1~999999，输入则表示需要支付一定积分参与竞拍，不输入则表示无需支付积分可直接出价参与）
                </span>
              </el-form-item>
              <el-form-item label="起拍价：" required>
                <el-input
                  v-model="ruleForm.startPrice"
                  class="w90"
                  placeholder="请输入"
                  @input="
                    ruleForm.startPrice = getNumberData(
                      1,
                      $event,
                      0,
                      1,
                      999999,
                    )
                  "
                  :disabled="activityData.isStart"
                ></el-input>
                <span class="ml8">积分</span>
                <span class="tip-color"> （仅支持输入1~999999） </span>
              </el-form-item>
              <el-form-item label="加价幅度：" required>
                <el-input
                  v-model="ruleForm.addPrice"
                  class="w90"
                  placeholder="请输入"
                  @input="
                    ruleForm.addPrice = getNumberData(
                      1,
                      $event,
                      0,
                      1,
                      999999,
                    )
                  "
                ></el-input>
                <span class="ml8">积分</span>
                <span class="tip-color">
                  （仅支持输入1~999999，表示每次出价必须在当前价的基础上至少增加XX积分）
                </span>
              </el-form-item>
              <el-form-item label="竞拍时间：" required>
                <div class="my_select_time_hd">
                  <el-date-picker
                    v-model="auctionTimeValue"
                    type="datetimerange"
                    class="rangeTime"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 400px"
                    :picker-options="pickerOptionsValue"
                    :default-time="auctionDefaultTime"
                    :clearable="false"
                    @change="changeAuctionTime"
                  >
                  </el-date-picker>
                  <i
                    class="el-icon-circle-close date_icon1"
                    @click="cleanTime()"
                    v-if="!activityData.isStart"
                  ></i>
                  <!-- <img
                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                    alt=""
                    class="date_icon2"
                  /> -->
                </div>
              </el-form-item>
              <el-form-item label="成交规则：" required>
                <el-radio-group
                  v-model="ruleForm.dealRuleType"
                  @change="ruleForm.dealTargetPrice = null"
                >
                  <el-radio :label="0" style="margin-top: 8px" >
                    出价高者得（在竞拍结束时，出价积分高的参与者获得竞拍奖品，当奖品数量大于1的时候，仅支持此种成交规则）
                  </el-radio>
                  <el-radio
                    :label="1"
                    style="margin-top: 8px"
                    :disabled="prizeNumber"
                  >
                    达到目标价
                    <el-input
                      v-model="ruleForm.dealTargetPrice"
                      class="w90"
                      placeholder="请输入"
                      @input="
                        ruleForm.dealTargetPrice = getNumberData(
                          1,
                          $event,
                          0,
                          1,
                          999999,
                        )
                      "
                      :disabled="ruleForm.dealRuleType !== 1 || isActStart"
                    ></el-input>
                    积分时自动成交（当有参与者的出价达到或超过该目标价格时，竞拍立即结束，该参与者成为成交者）
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="预留收货地址：" required>
                <el-radio-group
                  v-model="ruleForm.isReservedAddress"
                  :disabled="activityData.isStart"
                  style="display: flex;flex-direction: column;"
                  @change="changeEnableAddress"
                >
                  <el-radio :label="false" style="margin-top: 8px" >
                    不支持预留收货地址
                  </el-radio>
                  <el-radio
                    :label="true"
                    style="margin-top: 8px"
                  >
                    用户竞拍实物奖品时，支持预留收货地址（如实物奖品配置了附加信息时，不支持预留地址）
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="支付时间：" required>
                必须在成交后
                <el-input
                  v-model="ruleForm.payTime"
                  class="w90"
                  placeholder="请输入"
                  @input="
                    ruleForm.payTime = getNumberData(1, $event, 0, 1, 999999)
                  "
                  :disabled="activityData.isStart"
                ></el-input>
                <el-select
                  v-model="ruleForm.payTimeUnit"
                  placeholder="请选择"
                  style="width: 80px; margin-left: 8px"
                  :disabled="activityData.isStart"
                >
                  <el-option label="天" :value="0"></el-option>
                  <el-option label="小时" :value="1"></el-option>
                  <el-option label="分钟" :value="2"></el-option>
                </el-select>
                内支付积分，否则当逾期未支付，奖品失效处理（用户竞品成功后，系统会自动扣除积分，如积分不足，需在配置时间段内进入活动，手动支付积分）
                <jd-tip color="red" style="margin-top: 10px; width: 650px">
                  注意：支付有效期不可超过活动结束时间，超过时默认置为活动结束时间。建议把活动时间设置长一些哦~
                </jd-tip>
              </el-form-item>
          </div>
          <jd-title label="活动页设置"></jd-title>
          <div class="mt20 flex-sc">
          <!-- 活动页设置 -->
           <div class="set-left">
            <el-form-item label="拍品详情图：">
                      <div class="buttonGroupUI">
                        <el-upload
                          class="upload"
                          style="width: fit-content"
                          action="/jd-hd-web/image/upload"
                          :show-file-list="false"
                          accept="image/*"
                          :on-success="
                            (res) => handleUpload(res, 'auctionItemImageUrls')
                          "
                          :disabled="
                            activityData.backgroundOpacity ||
                            customerPaperwork.auctionItemImageUrls.length >= 6
                          "
                        >
                          <jd-button
                            type="blue"
                            :disabled="
                              activityData.backgroundOpacity ||
                              customerPaperwork.auctionItemImageUrls.length >= 6
                            "
                            >自定义上传</jd-button
                          >
                        </el-upload>
                        <span class="color-style">尺寸建议：660*986px</span>
                      </div>
                      <draggable
                        v-if="customerPaperwork.auctionItemImageUrls.length > 0"
                        v-model="customerPaperwork.auctionItemImageUrls"
                        chosen-class="chosen"
                        :scroll="true"
                        animation="150"
                        force-fallback="true"
                        @start="isDragging = true"
                        @end="isDragging = false"
                        class="draggable-box"
                        filter=".undraggable"
                        style="margin-top: 10px"
                      >
                        <transition-group type="transition">
                          <div
                            v-for="(item, index) in customerPaperwork.auctionItemImageUrls"
                            :key="index"
                            style="display: inline-block; position: relative"
                            class="show_upImg2"
                            :class="[activityData.backgroundOpacity ? 'undraggable' : '']"
                          >
                            <el-image
                              :src="item"
                              style="
                                width: 120px;
                                height: 120px;
                                display: inline-block;
                              "
                              fit="contain"
                            />&nbsp;
                            <div class="delectPosible" v-if="!activityData.backgroundOpacity">
                              <span class="delectSort">拖动排序</span>
                              <img
                                src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg"
                                @click.stop="
                                  customerPaperwork.auctionItemImageUrls.splice(index, 1)
                                "
                                class="delectIcom"
                              />
                            </div>
                          </div>
                        </transition-group>
                      </draggable>
            </el-form-item>
            <el-form-item label="积分字体颜色：">
                      <div class="buttonGroupUI">
                        <el-color-picker
                          v-model="customerPaperwork.pointTextColor"
                          size="small"
                        ></el-color-picker>
                        <dy-button
                          type="blueText"
                          style="margin-left: 16px"
                          @click="resetAll('pointTextColor')"
                          :disabled="activityData.backgroundOpacity"
                          >重置</dy-button
                        >
                      </div>
            </el-form-item>
            <el-form-item label="按钮设置：">
              <div
                style="
                  background: #f4f6fa;
                  padding: 20px 20px 20px 0;
                  width: fit-content;
                "
              >
                <el-form-item label="按钮背景图：" label-width="120px">
                  <div class="buttonGroupUI">
                    <el-upload
                      class="upload"
                      action="/jd-hd-web/image/upload"
                      :show-file-list="false"
                      :before-upload="
                        (file) =>
                          beforeUpload(file, 'buttonBackgroundColor')
                      "
                      :on-success="
                        (res) =>
                          handleUpload(res, 'buttonBackgroundColor')
                      "
                    >
                      <jd-button
                        type="blue"
                        label="自定义上传"
                        :disabled="activityData.backgroundOpacity"
                      ></jd-button>
                    </el-upload>
                    <dy-button
                      type="blueText"
                      @click="resetAll('buttonBackgroundColor')"
                      style="margin: 0 0 0 16px"
                      :disabled="activityData.backgroundOpacity"
                      >重置</dy-button
                    >
                    <span class="color-style"
                      >尺寸建议：{{
                        defaultUiConfig.buttonBackgroundColor.size[0]
                      }}*{{
                        defaultUiConfig.buttonBackgroundColor.size[1]
                      }}px</span
                    >
                  </div>
                </el-form-item>
                <el-form-item
                  label="按钮文字色："
                  label-width="120px"
                  style="margin-bottom: 0"
                >
                  <div class="buttonGroupUI">
                    <el-color-picker
                      v-model="customerPaperwork.buttonWordColor"
                      size="small"
                    ></el-color-picker>
                    <dy-button
                      type="blueText"
                      style="margin: 0 12px 0 16px"
                      @click="resetAll('buttonWordColor')"
                      :disabled="activityData.backgroundOpacity"
                      >重置</dy-button
                    >
                  </div>
                </el-form-item>
              </div>
              
            </el-form-item>
          </div>
          <div class="bg-box">
            <previewPageDialog
              :ruleForm="{
               ...customerPaperwork,
               ...ruleForm,
               tableData,
            }"
            :baseUrl="baseUrl"
            ></previewPageDialog>
          </div>
        </div>
          
          <!-- <exposureList
            :defaultExposureSwitch.sync="ruleForm.isExposureItem"
            v-model="itemListFor"
            :backgroundOpacity="activityData.backgroundOpacity"
            :isLimit="true"
          ></exposureList> -->
          <div class="pdb20">
            <jd-title label="展示店铺"></jd-title>
          </div>
          <el-form-item label="小程序店铺信息：" label-width="150px">
              <el-radio-group v-model="customerPaperwork.shopNameType">
                  <el-radio :label="0">统一显示配置店铺</el-radio>
                  <el-radio :label="2">不显示店铺信息</el-radio>
              </el-radio-group>
          </el-form-item>
          <sharFrom :sharePic="sharePic" v-model="ruleDTO"></sharFrom>
          <activityRules
            :isForceRemind.sync="isForceRemind"
            :isKeyActivity.sync="isKeyActivity"
            :placementPosition.sync="placementPosition"
            v-model="ruleForm.ruleDescription"
            :activityData="activityData"
            :valueRow="valueRow"
            @generateRule="generateRule"
          ></activityRules>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum == 0 || localStepNum == 1">
      <jd-button
        v-if="localStepNum != 0"
        v-show="!itemId"
        style="margin-right: 8px"
        @click="clickLocalStep()"
        >{{ activityData.backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <!-- <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn"
        >保存至草稿箱</jd-button
      > -->
      <template v-if="!activityData.backgroundOpacity">
        <jd-button
          v-show="!itemId"
          v-if="isSave"
          type="blue"
          @click="resetForm"
          v-preventReClick
          >保存设置</jd-button
        >
      </template>

      <jd-button v-show="itemId" style="margin-right: 8px" @click="cancelEdit"
        >取消</jd-button
      >
      <jd-button v-show="itemId" type="blue">保存设置</jd-button>
    </div>

    <!-- 保存设置弹框 -->
    <el-dialog
      title="重要提示"
      :visible.sync="joinBlackList"
      width="800"
      @close="checked = false"
    >
      <div v-loading="saveLoading">
        <div style="line-height: 25px; margin-bottom: 30px">
          <p>
            1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
          </p>
          <p>
            2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
          </p>
        </div>

        <el-checkbox v-model="checked" label="地址" name="partner"
          >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
        >
      </div>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button
          @click="handleDialogCloseAnoth()"
          type="blue"
          style="margin-left: 8px"
          v-loading="saveLoading"
          >确 定</jd-button
        >
      </div>
    </el-dialog>
    <selectGoods
      v-if="isShowSpecify"
      :isShow="isShowSpecify"
      @close="getSpecifyGoods"
      :selectGoods="showSelectGoods"
      :moduleType="true"
      :skuSearch="true"
      :isLimit="true"
      :limitNum="1"
      :disabled="activityData.backgroundOpacity"
    ></selectGoods>
    <!-- 奖品弹窗 -->
    <!-- <selectProduct
      ref="selectProductRef"
      v-if="isShowPrize"
      :echoDate="echoDate"
      :num="1"
      :actId="valueRow"
      :JingdouCount="JingdouCount"
      :isBindGoods="isBindGoods"
      :specifyId="specifyId"
      :isShowGiftCard="false"
      :isShowHongBao="false"
      :isShowPLUS="false"
      :isShowIQY="false"
      :isShowEK="false"
      :isShowThing="false"
      :isShowJingdou="false"
      :isShowCoupon="false"
      :hideShopPoints="true"
      :hasSelectIds="hasSelectIds"
      defaultSelect="twelve"
      @choose-shop="getTheData"
    >
    </selectProduct> -->
    <!-- 增加奖品弹窗 -->
    <addPrizeNum
      :isShowAddNum="isShowAddNum"
      :prizeData="toAddItem"
      @confirm="confirmAdd"
      @close="isShowAddNum = false"
    />
    <!-- 奖品弹窗 -->
    <selectProduct
      ref="selectProduct"
      v-if="showSelectProduct"
      :echoDate="echoDate"
      :num="1"
      :actId="valueRow"
      :JingdouCount="JingdouCount"
      :hideShopPoints="true"
      @choose-shop="getTheData"
    >
    </selectProduct>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import previewPageDialog from "./preview_page_dialog.vue";
import selectGoods from "@/components/selectGoodsMonitor2";
import selectProduct from "../../activity/select_product_componentization.vue";
import addPrizeNum from "../../activity/components/add-prize-num.vue";
import {
  saveActivityCommon,
  getActivityDetailCommon,
  pointAuctions
} from "@/api/jhk/integralCenter/PointActivityAnalyticController.js";
import { sellerImage } from "@/api/jhk/paradiseAndTaskCommonController.js";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import informationForm from "../../activity/components/informationForm.vue";
import exposureList from "../../activity/components/exposureList.vue";
import sharFrom from "../../activity/components/sharFrom.vue";
import activityRules from "../../activity/components/activityRules.vue";
import activityPageSettings from "../../activity/components/activityPageSettings.vue";
import groupBargainingPreviewDialog from "../../activity/components/newActPreviews/group-bargaining-preview-dialog.vue";
const baseImgUrl = "https://cdn-image.yucrm.cn/images/dy/pointAuction/";
const $globalCdn = "https://cdn-image.yucrm.cn/images/dyAssets"
export default {
  components: {
    informationForm,
    exposureList,
    sharFrom,
    activityRules,
    activityPageSettings,
    selectGoods,
    selectProduct,
    groupBargainingPreviewDialog,
    addPrizeNum,
    draggable,
    previewPageDialog
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    valueRow: {
      type: Object,
      default: () => {},
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    // 监听奖品列表变化
    tableData: {
      handler(newVal) {
        console.log('tableData changed:', newVal);
        // 触发 prizeNumber 重新计算
        this.$forceUpdate();
      },
      deep: true
    }
  },
  data() {
    return {
      isKeyActivity: 0,
      placementPosition: [],
      baseUrl: baseImgUrl,
      // 奖品列表
      tableData: [
        {
          sort: 0,
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: 0,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
        },
      ],
      isShowAddNum: false,
      prizeIndex: "",
      showSelectProduct:false, //选择奖品
      saveLoading: false,
      hasSelectIds: [],
      toAddItem: {},
      isShowAddNum: false,
      isBindGoods: true,
      prizeIndex: -1,
      JingdouCount: {
        prizeCount: 0,
      },
      isShowPrize: false,
      winLimit: 0,
      showSelectGoods: [],
      isShowSpecify: false,
      defaultLogo: "https://cdn-image.yucrm.cn/hd/images/prizeShow646.png",
      echoDate: {},
      priceObj: {},
      loading: false,
      templateObj: {},
      currrentRgb: "",
      currrentRgb2: "",
      currrentRgb3: "",
      currrentRgb4: "",
      currrentRgb5: "",
      currrentRgb6: "",
      currrentRgb7: "",
      customerPaperwork: {
        //积分竞价
        auctionItemImageUrls: [], // 拍品详情图
        pointTextColor: "#FF2929", // 积分文字颜色
        buttonWordColor: "#FFFFFF", // 主按钮文案颜色
        showMoreListUrl: $globalCdn + "/images/preview/more_activity.png", //自定义更多活动图标
        buttonBackgroundColor: baseImgUrl + "detail_auction_btn_bg.png",
        shopNameType: 0
      },
      // 默认UI字段配置
      defaultUiConfig: {
        buttonBackgroundColor: {
          defaultValue: baseImgUrl + "detail_auction_btn_bg.png",
          size: [580, 88],
        },
        buttonWordColor: {
          defaultValue: "#FFFFFF",
        },
        pointTextColor: {
          defaultValue: "#FF2929",
        },
      },
      actMember: "1",
      peopleSelected: [],
      templateId: "",
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      giftList: [],
      itemListFor: [], //商品弹框选择商品数据
      joinBlackList: false,
      checked: false,
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      ruleForm: {
        startTime: "",
        endTime: "",
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],
        allowLevel: "-1",
        activityName: "",
        openCardFollow: 0,
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "",
        // 购物条件 - 累计完成订单笔数
        orderCompleteLimitCount: "", // 最小订单笔数
        orderCompleteMaxCount: "", // 最大订单笔数
        // 购物条件 - 累计完成订单金额
        orderCompleteLimitPayment: "", // 最小订单金额
        orderCompleteMaxPayment: "", // 最大订单金额
        // 购物条件 - 最后一次订单完成时间
        lastOrderCompleteTimeType: 0, // 时间类型: 0-不限, 1-距当前天数范围, 2-指定时间段
        lastOrderCompleteStartDay: "", // 距当前开始天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteEndDay: "", // 距当前结束天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteStartTime: "", // 指定开始时间 (当 lastOrderCompleteTimeType='2' 时)
        lastOrderCompleteEndTime: "", // 指定结束时间 (当 lastOrderCompleteTimeType='2' 时)


        // 此活动使用字段
        ticket: null, // 竞拍门票
        startPrice: null, // 起拍价
        addPrice: null, // 加价幅度
        dealRuleType: 0, // 成交规则
        dealTargetPrice: null, // 目标价
        payTime: null,
        payTimeUnit: 0,
        isReservedAddress: false, // 是否预留收货地址
      },
      // 新增字段
      auctionTimeValue: [], // 竞拍时间
      itemArr: [], // 奖品数组
      ruleDTO: {
        customerPaperwork: "",
        cusTemplateJSON: "",
        plusObject: 0,
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "",
        openCardStartTime: "",
        openCardEndTime: "",
      },
      bargainConfig: {
        firstBargainAmountUpperLimit: "",
        firstBargainAmountLowerLimit: "",
        newMemberBargainAmountUpperLimit: "",
        newMemberBargainAmountLowerLimit: "",
        oldMemberBargainAmountUpperLimit: "",
        oldMemberBargainAmountLowerLimit: "",
        inviteLimitType: 0,
      },
      tableInfo: [
        {
          label: "商品图",
          slot: "logoSlot",
        },
        {
          label: "商品名称",
          slot: "titleSlot",
        },
        {
          label: "skuID",
          prop: "skuId",
        },
        {
          label: "京东价",
          slot: "priceSlot",
        },
        {
          label: "操作",
          slot: "actionSlot",
        },
      ],
      specifytList: [
        {
          skuId: "",
          skuName: "",
          logo: "",
          jdPrice: "",
        },
      ],
      sharePic: "",
      activityStartTime: null,
      activityEndTime: null,
      templateJson: {
        templateUItype: "",
      },
      levelList: [],
      isDraft: false,
      prizeList: [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: 0,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          reducePrice: null, // 减价
          successInviteNum: null, // 成功邀请人数
        },
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: 0,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          reducePrice: null, // 减价
          successInviteNum: null, // 成功邀请人数
        },
      ],
      bargainInfo: [
        { label: "奖品名称", prop: "title", minWidth: 180 },
        { label: "奖品类型", slot: "prizeTypeSlot", minWidth: 180 },
        { label: "商品图片", slot: "logoSlot", minWidth: 180 },
        { label: "减价", slot: "discountSlot", minWidth: 180 },
        { label: "优惠后价格", slot: "discountedSlot", minWidth: 180 },
        { label: "奖品库存", slot: "inventorySlot", minWidth: 180 },
        { label: "操作", slot: "actionSlot", minWidth: 200, fixed: "right" },
      ],
      inviteInfo: [
        { label: "成功邀请人数", slot: "inviteSlot", minWidth: 190 },
        { label: "奖品名称", prop: "title", minWidth: 180 },
        { label: "奖品类型", slot: "prizeTypeSlot", minWidth: 180 },
        { label: "商品图片", slot: "logoSlot", minWidth: 180 },
        { label: "减价", slot: "discountSlot", minWidth: 180 },
        { label: "优惠后价格", slot: "discountedSlot", minWidth: 180 },
        { label: "奖品库存", slot: "inventorySlot", minWidth: 180 },
        { label: "操作", slot: "actionSlot", minWidth: 220, fixed: "right" },
      ],
    };
  },
  computed: {
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    commonInfo() {
      return this.bargainConfig.bargainType == 0
        ? this.bargainInfo
        : this.inviteInfo;
    },
    specifyId() {
      return this.specifytList.length > 0 ? this.specifytList[0].skuId : "";
    },
    isActStart() { //根据状态控制
      // const status = sessionStorage.getItem("status") || "";
      // return status == 2 && !this.isCopy && !this.activityData.isCopy;
    },
    pickerOptionsValue() {
      return {
        disabledDate: (time) => {
          // 如果有活动开始时间和结束时间，只能选择活动时间范围内的时间，可等于活动时间
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000 + 1 ||
            (this.endTime &&
              time.getTime() > new Date(this.endTime).valueOf()) ||
            (this.startTime &&
              time.getTime() <
                new Date(this.startTime).valueOf() - 24 * 60 * 60 * 1000)
          );
        },
      };
    },
    auctionDefaultTime() {
      let timeStart = this.startTime
        ? this.startTime.substring(11, this.startTime.length)
        : "00:00:00";
      let timeEnd = this.endTime
        ? this.endTime.substring(11, this.endTime.length)
        : "23:59:59";
      return [timeStart, timeEnd];
    },
    // 计算奖品数量
    prizeNumber() {
      // 检查是否有任何一个奖品的数量大于1
      const result = this.tableData.some(item => {
        // 确保 item.totalAmount 是数字类型，并且大于1
        const isGreaterThan1 = Number(item.totalAmount) > 1;
        if(isGreaterThan1){
          this.ruleForm.dealRuleType = 0
          this.ruleForm.dealTargetPrice = null
        }
        return isGreaterThan1;
      });
      return result;
    },
  },
  created() {
    this.sharePic = this.getDefaultSharePic(70);
    this.ruleDTO.sharePic = this.sharePic;
    this.ruleDTO.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleDTO.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
  },
  mounted() {
    this.getLevel();
    this.getDetail();
    this.buriedPoint(1, "积分竞拍", "互动管理", "互动活动");
  },

  methods: {
    changeEnableAddress(val) {
     const flag = this.tableData.some((item)=>{
        return item.prizeType == 3 && item.shouldCollectExtraData == 1
      })
      if(val&&flag) {
        this.$message.warning("实物奖品中有奖品配置了附加信息，不支持预留地址操作")
        this.ruleForm.isReservedAddress = false;
      }
    },
     resetAll(field) {
        // 检查 defaultUiConfig 中是否有该字段的默认值
         if (this.defaultUiConfig[field] && this.defaultUiConfig[field].defaultValue) {
         this.customerPaperwork[field] = this.defaultUiConfig[field].defaultValue;
         } else {
        // 如果没有默认值，根据字段类型设置合理的默认值
       if (field === 'pointTextColor') {
          this.customerPaperwork[field] = '#FF2929'; // 积分字体默认颜色
       } else if (field === 'buttonWordColor') {
          this.customerPaperwork[field] = '#FFFFFF'; // 按钮文字默认颜色
       } else if (field === 'buttonBackgroundColor') {
          this.customerPaperwork[field] = this.defaultUiConfig.buttonBackgroundColor.defaultValue;
       }
      }
     },
    //上传图片前校验
    async beforeUpload(file, field) {
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg", ".jpeg", ".gif"];

      if (sorts.indexOf(type) < 0) {
        this.$message.info("图片格式不符合要求，请重新上传");
        await Promise.reject();
        return false;
      }
      const size = this.defaultUiConfig[field].size;
      await this.imgchecked(file, size[0], size[1]);
    },
      // 上传成功
    handleUpload(res, field) {
     if (res.code != 1) {
       this.$message.error(res.message); // 修复拼写错误
     } else {
       let url = res.data;
       if (field == "auctionItemImageUrls") {
         this.customerPaperwork.auctionItemImageUrls.push(url);
       } else {
         this.customerPaperwork.buttonBackgroundColor = url
       }
       this.$message.success("图片上传成功~");
      }    
     },
    changeAuctionTime(val) {
       // 空值检查
       if (!val || !Array.isArray(val)) {
         this.auctionTimeValue = [];
         this.ruleForm.auctionStartTime = '';
         this.ruleForm.auctionEndTime = '';
         return;
       }
       
       if (
        val[0] &&
        new Date(val[0]).valueOf() < new Date(this.startTime).valueOf()
       ) {
        this.auctionTimeValue = [this.startTime, val[1]];
        this.ruleForm.auctionStartTime = this.startTime;
        this.ruleForm.auctionEndTime = val[1];
       } else if (
        val[1] &&
        new Date(val[1]).valueOf() > new Date(this.endTime).valueOf()
       ) {
         this.auctionTimeValue = [val[0], this.endTime];
         this.ruleForm.auctionStartTime = val[0];
         this.ruleForm.auctionEndTime = this.endTime;
       } else {
         this.auctionTimeValue = val;
         this.ruleForm.auctionStartTime = val[0];
         this.ruleForm.auctionEndTime = val[1];
       }
     },
     cleanTime() {
      this.auctionTimeValue = [];
     },
     //奖品数据
     getTheData(data, prizeType) {
      //处理奖品返回字段公共部分
      let prizeObj = {
        price: "",
        assetsId: "",
        logo: "",
        prizeType: 0,
        title: "",
      };
      if (prizeType == 1) {
        prizeObj.couponType = data.couponType;
      }
      if (data.giftType) {
        prizeObj.giftType = Number(data.giftType);
      }
      prizeObj.price = Number(data.discount);

      prizeObj.assetsId = data.couponId ? Number(data.couponId) : data.skuId;
      prizeObj.logo = data.logo || this.defaultLogo;
      prizeObj.prizeType = prizeType;

      if (prizeType == 4) {
        prizeObj.title = data.discount + "店铺积分";
      } else {
        prizeObj.title = data.name;
      }

      if (data.singleAmount) {
        prizeObj.singleAmount = data.singleAmount;
      }
      if (prizeType == 2) {
        prizeObj.quantityTotal = data.quantityTotal;
      }
      if (prizeType == 3) {
        if (!data.isGoodManage) {
          prizeObj.skuId = data.skuId;
          delete prizeObj.isGoodManage;
        } else {
          prizeObj.isGoodManage = data.isGoodManage;
        }
        prizeObj.predictSendTime = data.predictSendTime;
        prizeObj.isFollowActivityEndTime = data.isFollowActivityEndTime ? data.isFollowActivityEndTime : 0;
        prizeObj.addressFillEndTime = data.addressFillEndTime;
        prizeObj.addressFillLimit = data.addressFillLimit;
        prizeObj.shouldCollectExtraData = data.shouldCollectExtraData;
        prizeObj.extraQuestion = data.extraQuestion ? data.extraQuestion : null;
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        prizeObj.budgetRemain = data.budgetRemain;
      }
      if (prizeType == 3 && data.isGoodManage) {
        prizeObj.budgetRemain = data.budgetRemain;
      }
      // 实物随单发
      if(prizeType == 14 || prizeType == 1) {
        this.getPhysicalShipped(prizeObj,prizeType,data);
      }
      //奖品设置
      this.$set(this.tableData, this.prizeIndex, prizeObj);
      this.showSelectProduct = false;
     },
     //选择奖品  
     centerVis(scope, type, stepIndex) {
      this.JingdouCount.prizeCount = scope.row.totalAmount;
      this.prizeIndex = scope.$index;
      this.echoDate = scope.row;
      this.showSelectProduct = true;
      this.itemArr = this.tableData
      this.$nextTick(() => {
          this.$refs.selectProduct.openDialog();
      });
     },
     //增加库存 
     addStock(scope, type, stepIndex) {
      console.log(scope.row,'6546546545');
      this.toAddItem = {
        ...scope.row,
        num: scope.row.totalAmount,
      };
      this.isShowAddNum = true;
      this.prizeIndex = scope.$index;
    },
    //活动进行中修改奖品数量
    beAdd(row) {
      if (this.activityData.isStart) {
        if (row.totalAmount < row.minNum && row.minNum) {
          row.totalAmount = row.minNum;
          this.$message.error("为避免客诉，奖品数量不能小于之前哦~");
        }
      }
    },
    // 京东计划数量计算
    prizeNum(row) {
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if ([5, 6, 7, 8, 10].includes(Number(row.prizeType))) {
        if (
          Number(row.totalAmount) &&
          Number(row.totalAmount) > row.budgetRemain
        ) {
          row.totalAmount = "";
          if (row.prizeType == 5)
            this.$message.error(
              "京东E卡总份额数量不能大于该京东E卡剩余预算额！"
            );
          if (row.prizeType == 6)
            this.$message.error(
              "爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！"
            );
          if (row.prizeType == 7)
            this.$message.error(
              "京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！"
            );
          if (row.prizeType == 8)
            this.$message.error(
              "现金红包总份额数量不能大于该现金红包剩余预算额！"
            );
          if (row.prizeType == 10)
            this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！");
        }
      }
    },
    checkputn(e, row = {}) {
      if (
        row.quantityTotal &&
        row.price &&
        row.totalAmount &&
        row.prizeType == 2
      ) {
        let numTotal = this.$jingdouTotal({
          ...row,
          prizeCount: row.totalAmount,
        });
        if (!numTotal) {
          this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
        }
        return numTotal;
      } else {
        return row.totalAmount;
      }
    },
    getMemberFn(val) {
      this.ruleForm.firstOpenCardTimeType = 0;
      this.ruleForm.openCardBeforeDay = "";
      this.ruleDTO.openCardStartTime = "";
      this.ruleDTO.openCardEndTime = "";
      this.ruleDTO.plusObject = 0;
      this.ruleForm.partner = ["-1"];
      this.peopleSelected = []
    },
    confirmAdd(num) {
      this.$set(this.prizeList[this.prizeIndex], "totalAmount", Number(num));
      this.isShowAddNum = false;
    },
    changeBargainType(val) {
      if (val == 1) {
        this.bargainConfig.firstBargainAmountUpperLimit = "";
        this.bargainConfig.firstBargainAmountLowerLimit = "";
        this.bargainConfig.newMemberBargainAmountUpperLimit = "";
        this.bargainConfig.newMemberBargainAmountLowerLimit = "";
        this.bargainConfig.oldMemberBargainAmountUpperLimit = "";
        this.bargainConfig.oldMemberBargainAmountLowerLimit = "";
      }
    },
    handlePrizeLimit(row, rowIndex) {
      return this.prizeList.some((item, index) => {
        if (index < rowIndex) {
          if (
            item.prizeType &&
            Number(item.reducePrice) > 0 &&
            Number(item.reducePrice) >= Number(row.reducePrice)
          ) {
            this.$message.warning("当前奖品减价金额需大于前一个奖品的减价金额");
            return true;
          }
        } else if (index > rowIndex) {
          if (
            item.prizeType &&
            Number(item.reducePrice) > 0 &&
            Number(item.reducePrice) <= Number(row.reducePrice)
          ) {
            this.$message.warning("当前奖品减价金额需小于后一个奖品的减价金额");
            return true;
          }
        }
      });
    },
    getDisCountAmount(row, rowIndex) {
      //  TODO: 根据所选择指定商品specifytList的原价和是否填写了优惠后的价格计算减价
      if (row.reducePrice >= this.specifytList[0].jdPrice) {
        row.reducePrice = this.specifytList[0].jdPrice;
      }
      row.price = (this.specifytList[0].jdPrice - row.reducePrice).toFixed(2);
      let flag = this.handlePrizeLimit(row, rowIndex);
      if (flag) {
        row.reducePrice = "";
      }
    },
    getDisCountedPrice(row, rowIndex) {
      //  TODO: 根据所选择指定商品specifytList的原价和是否填写了减价计算优惠后的价格
      if (row.price >= this.specifytList[0].jdPrice) {
        row.price = this.specifytList[0].jdPrice;
      }
      row.reducePrice = (this.specifytList[0].jdPrice - row.price).toFixed(2);
      let flag = this.handlePrizeLimit(row, rowIndex);
      if (flag) {
        row.reducePrice = "";
      }
    },
    addPrizeList() {
      this.prizeList.push({
        assetsId: null, // 资产项id(计划id优惠卷id商品id)
        prizeType: 0,
        price: null,
        logo: null,
        title: "",
        totalAmount: null,
        reducePrice: null, // 减价
        successInviteNum: null, // 成功邀请人数
      });
    },
    // selectPrize(row, index) {
    //   this.prizeIndex = index;
    //   this.JingdouCount.prizeCount = row.totalAmount;
    //   this.echoDate = row;
    //   this.isShowPrize = true;
    //   this.itemArr = this.prizeList;
    //   this.hasSelectIds = this.prizeList
    //     .filter((item) => item.assetsId != row.assetsId)
    //     .map((item) => item.assetsId + "");
    //   this.$nextTick(() => {
    //     this.$refs.selectProductRef.openDialog();
    //   });
    // },
    deletePrize(rowIndex) {
      // 删除商品
      this.prizeList.splice(rowIndex, 1);
    },
    getPriceNum(value) {
      return value
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".")
        .replace(/[^\d.]/g, "")
        .replace(/^(\-)*(\d+)\.(\d).*$/, "$1$2.$3");
    },
    getPriceNumLimit(val, key, type) {
      let str = Number(val.target.value);
      if (str <= 0) {
        return "";
      } else {
        if (type == "first") {
          if (
            this.bargainConfig[key] &&
            str > Number(this.bargainConfig[key])
          ) {
            this.$message.warning("前位金额不可大于后位金额");
            return "";
          }
        } else if (type == "end") {
          if (
            this.bargainConfig[key] &&
            str < Number(this.bargainConfig[key])
          ) {
            this.$message.warning("后位金额不能小于前位金额");
            return "";
          }
        }
        let newStr = str + "";
        console.log(newStr, "bbbb");
        let index = newStr.indexOf(".");
        if (index != -1 && newStr[index + 1]) {
          return str;
        } else if (index != -1 && !newStr[index + 1]) {
          return "";
        }
        return (str + "").indexOf(".") != -1 ? str : str + ".0";
      }
    },
    selectGoodsFn() {
      this.isShowSpecify = true;
    },
    getSpecifyGoods(data) {
      if (data && data.length > 0) {
        this.showSelectGoods = [];
        data.forEach((item) => {
          let obj = {
            skuId: "",
            skuName: "",
            logo: "",
            jdPrice: "",
          };
          obj.skuId = item.skuId;
          obj.skuName =
            (item.wareTitle || item.skuName).length > 12
              ? (item.wareTitle || item.skuName).slice(0, 12)
              : item.wareTitle || item.skuName;
          obj.logo = item.logo;
          obj.jdPrice = item.jdPrice;
          this.showSelectGoods.push(obj);
          this.specifytList = this.showSelectGoods;
        });
      }
      this.isShowSpecify = false;
    },
    //判断尺寸方法 默认200*200
    imgchecked(file, width = 200, height = 200) {
      let _this = this;
      return new Promise((resolve, reject) => {
        let type = file.name
          .substring(file.name.lastIndexOf("."))
          .toLowerCase();
        let sorts = [".png", ".jpg"];
        if (sorts.indexOf(type) < 0) {
          reject();
          this.$message.info("所选图片格式不符，请重新选择");
        } else {
          let image = new Image();
          let _URL = window.URL || window.webkitURL;
          image.onload = function () {
            const valid = image.width == width && image.height == height;
            file.isFlag = valid;
            if (valid) {
              resolve(true);
            } else {
              _this.$message.info("图片尺寸不符合要求，请重新上传");
              reject();
            }
          };
          image.src = _URL.createObjectURL(file);
        }
      });
    },
    async beforeUploadPrize(file) {
      const status = await this.imgchecked(file, 200, 200);
      if (!status) {
        return false;
      }
    },
    uploadLogo(val, row) {
      row.logo = val.data;
    },
    // 背景图上传校验
    async beforeUploadUI(file, type) {
      let sizeype = {
        1: {
          width: 162,
          height: 58,
        },
        2: {
          width: 56,
          height: 56,
        },
        3: {
          width: 136,
          height: 136,
        },
        4: {
          width: 584,
          height: 96,
        },
      };
      const status = await this.imgchecked(
        file,
        sizeype[type].width,
        sizeype[type].height
      );
      if (!status) {
        return false;
      }
    },
    // 背景图上传图片
    handleUploadUI(res, type) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        if (type == 1) {
          this.customerPaperwork.productModuleBtnUrl = res.data;
          this.$message.success("背景图上传成功");
        } else if (type == 2) {
          this.customerPaperwork.amountStageUrl = res.data;
          this.$message.success("砍价阶段icon图上传成功");
        } else if (type == 3) {
          this.customerPaperwork.inviteStageUrl = res.data;
          this.$message.success("砍价阶段icon图上传成功");
        } else if (type == 4) {
          this.customerPaperwork.mainBtnUrl = res.data;
          this.$message.success("背景图上传成功");
        }
      }
    },
    getPrizeCommon(data, prizeType) {
      //处理奖品返回字段公共部分
      let prizeObj = {
        price: "",
        assetsId: "",
        logo: "",
        prizeType: "",
        title: "",
      };
      if (prizeType == 1) {
        prizeObj.couponType = data.couponType;
      }
      if (data.giftType) {
        prizeObj.giftType = Number(data.giftType);
      }
      prizeObj.price =
        prizeType == 13 && data.discount == "" ? "" : Number(data.discount);

      prizeObj.assetsId = data.couponId ? Number(data.couponId) : data.skuId;
      prizeObj.logo = data.logo || this.defaultLogo;
      prizeObj.prizeType = prizeType;

      if (prizeType == 4) {
        prizeObj.title = data.discount + "店铺积分";
      } else {
        prizeObj.title = data.name;
      }

      if (data.singleAmount) {
        prizeObj.singleAmount = data.singleAmount;
      }
      if (prizeType == 2) {
        prizeObj.quantityTotal = data.quantityTotal;
      }
      if (prizeType == 3) {
        if (!data.isGoodManage) {
          prizeObj.skuId = data.skuId;
          delete prizeObj.isGoodManage;
        } else {
          prizeObj.isGoodManage = data.isGoodManage;
        }
        prizeObj.predictSendTime = data.predictSendTime;
        prizeObj.isFollowActivityEndTime = data.isFollowActivityEndTime ? data.isFollowActivityEndTime : 0;
        prizeObj.addressFillEndTime = data.addressFillEndTime;
        prizeObj.addressFillLimit = data.addressFillLimit;
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        prizeObj.budgetRemain = data.budgetRemain;
      }
      if (prizeType == 3 && data.isGoodManage) {
        prizeObj.budgetRemain = data.budgetRemain;
      }
      if (prizeType == 12) {
        prizeObj.reducePrice = data.reducePrice;
      }
      return prizeObj;
    },
    // getTheData(data, prizeType) {
    //   let prizeObj = this.getPrizeCommon(data, prizeType);
    //   let flag = false;
    //   if (prizeType == 12) {
    //     flag = this.handlePrizeLimit(prizeObj, this.prizeIndex);
    //     // flag = this.prizeList.some((item, index) => {
    //     //   if (index < this.prizeIndex) {
    //     //     if (
    //     //       item.prizeType &&
    //     //       Number(item.discountAmount) > Number(prizeObj.discountAmount)
    //     //     ) {
    //     //       this.$message.warning(
    //     //         "当前奖品减价金额需大于前一个奖品的减价金额"
    //     //       );
    //     //       return true;
    //     //     }
    //     //   } else if (index > this.prizeIndex) {
    //     //     if (
    //     //       item.prizeType &&
    //     //       Number(item.discountAmount) < Number(prizeObj.discountAmount)
    //     //     ) {
    //     //       this.$message.warning(
    //     //         "当前奖品减价金额需小于后一个奖品的减价金额"
    //     //       );
    //     //       return true;
    //     //     }
    //     //   }
    //     // });
    //   }
    //   if (flag) {
    //     return;
    //   } else {
    //     // 阶梯奖品
    //     this.$set(
    //       this.prizeList[this.prizeIndex],
    //       "assetsId",
    //       prizeObj.assetsId
    //     );
    //     this.$set(
    //       this.prizeList[this.prizeIndex],
    //       "prizeType",
    //       prizeObj.prizeType
    //     );
    //     this.$set(this.prizeList[this.prizeIndex], "logo", prizeObj.logo);
    //     this.$set(this.prizeList[this.prizeIndex], "title", prizeObj.title);
    //     this.$set(this.prizeList[this.prizeIndex], "price", prizeObj.price);
    //     this.$set(
    //       this.prizeList[this.prizeIndex],
    //       "totalAmount",
    //       this.prizeList[this.prizeIndex].totalAmount
    //     );
    //     this.$set(
    //       this.prizeList[this.prizeIndex],
    //       "reducePrice",
    //       prizeObj.reducePrice
    //     );
    //     this.$set(
    //       this.prizeList[this.prizeIndex],
    //       "successInviteNum",
    //       this.prizeList[this.prizeIndex].successInviteNum
    //     );
    //     this.isShowPrize = false;
    //   }
    // },
    initCustomizeData(row) {
      // let configJson = row.configJson && JSON.parse(row.configJson);
      // this.customerPaperwork.mainBtnColor = row.rgb;
      // this.customerPaperwork.titleColor = row.rgb2;
      // this.customerPaperwork.productModuleBtnColor = row.rgb3;
      // this.customerPaperwork.stageColor = configJson.rgb5;
      // this.customerPaperwork.variableColor = configJson.rgb4;
      // this.customerPaperwork.progressLeftColor = configJson.rgb6;
      // this.customerPaperwork.progressRightColor = configJson.rgb7;
      // this.currrentRgb = row.rgb;
      // this.currrentRgb2 = row.rgb2;
      // this.currrentRgb3 = row.rgb3;
      // this.currrentRgb4 = configJson.rgb4;
      // this.currrentRgb5 = configJson.rgb5;
      // this.currrentRgb6 = configJson.rgb6;
      // this.currrentRgb7 = configJson.rgb7;
    },
    selectTemplate(index, id, item) {
      this.templateObj = item;
      this.templateId = id;
      this.templateJson.templateUItype = index;
      this.initCustomizeData(item);
    },
    onShopSetChange() {
      this.ruleDTO.goShopAppId = "";
      this.ruleDTO.goShopUrl = "";
    },

    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      this.getPolite();
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: "",
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.giftList =
        data.records && data.records.length > 0
          ? data.records.map((item) => {
              return {
                ...item,
                days: item.activityStartTime
                  ? this.getDaysBetween(
                      item.activityStartTime,
                      item.activityEndTime
                    )
                  : "",
              };
            })
          : [];
      if (!this.templateId && this.giftList.length > 0) {
        this.templateObj = this.giftList[0];
        this.templateId = this.giftList[0].id;
        this.templateJson.templateUItype = 0;
        this.initCustomizeData(this.templateObj);
      } else if (this.templateId) {
        let arr = this.giftList.filter((item) => item.id == this.templateId);
        this.templateObj = arr[0];
        this.templateId = this.templateId;
        let configJson =
          this.templateObj.configJson &&
          JSON.parse(this.templateObj.configJson);
        this.currrentRgb = this.templateObj.rgb;
        this.currrentRgb2 = this.templateObj.rgb2;
        this.currrentRgb3 = this.templateObj.rgb3;
        this.currrentRgb4 = configJson.rgb4;
        this.currrentRgb5 = configJson.rgb5;
        this.currrentRgb6 = configJson.rgb6;
        this.currrentRgb7 = configJson.rgb7;
        this.customerPaperwork.titleColor = this.customerPaperwork.titleColor;
        this.customerPaperwork.productModuleBtnColor =
          this.customerPaperwork.productModuleBtnColor;
        this.customerPaperwork.stageColor = this.customerPaperwork.stageColor;
        this.customerPaperwork.mainBtnColor =
          this.customerPaperwork.mainBtnColor;
        this.customerPaperwork.variableColor =
          this.customerPaperwork.variableColor;
        this.customerPaperwork.progressLeftColor =
          this.customerPaperwork.progressLeftColor;
        this.customerPaperwork.progressRightColor =
          this.customerPaperwork.progressRightColor;
      }
      this.pageData.total = data.total * 1;
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => {});
    },
    joinRuleText(arr, joinType = 2) {
      let newText = "";
      let newNum = 1;
      arr.forEach((item) => {
        if (item && item.length > 0) {
          //如果判断字符串后面有分号或者顿号，就不添加分号或者顿号
          let isShowfh = item.trim().endsWith(";") || item.trim().endsWith("；") || item.trim().endsWith("。");
          // console.log("item>>", item, isShowfh);
          let joinTypeText = "";
          if (joinType === 3) {
            joinTypeText = "（" + newNum + "）";
          } else if (joinType === 2) {
            joinTypeText = newNum + ".";
          } else {
            joinTypeText = "";
          }
          // joinRuleText为1（大类）需要添加换行符
          let text = joinTypeText + item + (isShowfh ? "" : ";") + "\n" + (joinType == 1 ? "\n" : "");
          newText = newText + text;
          newNum = newNum + 1;
        }
      });
      return newText.trim();
    },
    //生成规则
    generateRule() {
      const {firstText,precautions} = this.getCommonText(this.levelList,this.ruleForm,this.ruleDTO,this.actMember)
      // 新增规则
      let dealText =
        this.ruleForm.dealRuleType == 0
          ? "出价高者得（在竞拍结束时，出价积分高的参与者获得竞拍奖品）"
          : `达到目标价${this.ruleForm.dealTargetPrice}积分时自动成交（当有参与者的出价达到或超过该目标价格时，竞拍立即结束，该参与者成为成交者）`;

      let timeTypeArr = {
        0: "天",
        1: "小时",
        2: "分钟",
      };
      let finishTimeValue = `${this.ruleForm.payTime}${
        timeTypeArr[this.ruleForm.payTimeUnit]
      }`;
      let newRuleText_2_arr = [
        "支付对应拍品的【竞拍门票】，获得参与资格，无竞拍门票的活动可直接出价参与",
        "在竞拍有效期内，点击【立即出价】参与竞拍",
        "若有买家同时出价，出价早的人可成功出价，后出价的人需要刷新页面才可以出价",
        `成交规则：${dealText}`,
        `中拍者，必须在成交后${finishTimeValue}内支付积分，只有支付成功后才视为竞拍成功，逾期未支付视为放弃奖品，并且将会影响您下次参与活动`,
      ];

      let newRuleText_3_arr = [
        "起拍价定义：物品由卖方自行上拍、设置起拍价。买方出价不得低于起拍价",
        "加价幅度定义：用户每次出价，都需依照加价幅度的要求进行加价出价",
        "竞价时间内买方出价竞拍，按照报价高低、竞拍数量多少、出价时间先后进行排名",
        "每次竞拍买方不限制出价次数，买方出价之后，经系统提示显示报价则出价成功，计出价一次。",
      ];

      let newRuleText_2 =
        "\n二、【如何参与】" + "\n" + this.joinRuleText(newRuleText_2_arr, 2);
      let newRuleText_3 =
        "\n三、【出价规则】" + "\n" + this.joinRuleText(newRuleText_3_arr, 2);
      let newRuleText_5 = "四、【注意事项】";

      let Arr1 = [
        firstText,
        [newRuleText_2],
        [newRuleText_3],
        [newRuleText_5,precautions]
      ];
      let newText = "";

      Arr1.forEach((item, index) => {
        let newNum = 0;
        item.forEach((row, it) => {
          if (row.length > 0) {
            if (it != 0) {
              newText = newText + newNum + "." + row + "\n";
            } else {
              newText = newText + row + "\n";
            }
            newNum = newNum + 1;
          }
        });
      });
      this.ruleForm.ruleDescription = newText.trim();
    },
    // 返回上一步
    returnBack() {
      this.$emit("returnStep");
      // if (this.valueRow && this.valueRow.id) {
      //   this.$emit("returnBack");
      //   return;
      // }
      // if (this.localStepNum == 0) this.$emit("returnBack");
      // if (this.localStepNum == 1) this.localStepNum = 0;
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },

    // 下一步
    resetForm() {
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      //活动对象限制
      if (
        this.actMember == 2 &&
        (!this.ruleForm.partner || this.ruleForm.partner.length == 0)
      ) {
        this.$message.warning("请选择活动对象");
        return;
      }
      if (this.actMember == 3 && !this.peopleSelected.length) {
        this.$message.warning("请选择指定人群");
        return;
      }

      // 1.14迭代 这里判断 指定入会时间
      if (this.actMember == "2") {
        if (
          this.ruleForm.firstOpenCardTimeType == 1 &&
          !this.ruleForm.openCardBeforeDay
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
        if (
          this.ruleForm.firstOpenCardTimeType == 2 &&
          (!this.ruleDTO.openCardStartTime || !this.ruleDTO.openCardEndTime)
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
        // 最后一次订单完成时间
        if (
          this.ruleForm.lastOrderCompleteTimeType == 1 &&
          !this.ruleForm.lastOrderCompleteEndDay &&
          !this.ruleForm.lastOrderCompleteStartDay
        ) {
          return this.$message.warning("最后一次订单完成时间");
        }

        if (
          this.ruleForm.lastOrderCompleteTimeType == 2 &&
          !this.ruleForm.lastOrderCompleteStartTime &&
          !this.ruleForm.lastOrderCompleteEndTime
        ) {
          return this.$message.warning("最后一次订单完成时间");
        }
      }

      //奖品设置
      if(this.tableData[0].title == '') {
        return this.$message.warning("请添加奖品");
      }

      //奖品校验
      if (this.tableData.some((item) => !item.totalAmount || item.totalAmount =='')) {
        return this.$message.warning("请输入奖品数量");
      }

      //起拍价，加价幅度校验
      if (!this.ruleForm.startPrice) {
        return this.$message.warning("请输入起拍价");
      } 

      if (!this.ruleForm.addPrice) {
        return this.$message.warning("请输入加价幅度");
      } 

      //竞拍时间校验
      if (!this.auctionTimeValue || this.auctionTimeValue.length < 2 || !this.auctionTimeValue[0] || !this.auctionTimeValue[1]) {
        return this.$message.warning("请输入竞拍时间");
      }

      //成交规则和支付时间校验
      if (this.ruleForm.dealRuleType  == 1 && (!this.ruleForm.dealTargetPrice || this.ruleForm.dealTargetPrice == '')) {
        return this.$message.warning("请输入成交目标价格");
      }
      // 预留地址修改
      const flag = this.tableData.some((item)=>{
        return item.prizeType == 3 && item.shouldCollectExtraData == 1
      })
      if(this.ruleForm.isReservedAddress&&flag) {
        this.$message.warning("实物奖品中有奖品配置了附加信息，不支持预留地址操作")
        // this.ruleForm.isReservedAddress = false;
        return
      }

      if (!this.ruleForm.payTime) {
        return this.$message.warning("请选择支付时间");
      }
      
      // 小程序分享标题
      if (!this.ruleDTO.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      // 小程序分享简介
      if (!this.ruleDTO.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }

      let start = new Date(this.ruleForm.endTime).valueOf();
      let end = new Date(this.auctionTimeValue[0]).valueOf();

      if(start < end){ 
        return this.$message.warning("竞拍开始时间不能大于活动结束时间");
      }
      if(this.placementPosition.length==0) {    
        this.$message.warning("请选择活动投放位置！");
        return
      }

      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    async handleDialogCloseAnoth() {
      let ruleDTO = {
        ...this.ruleDTO,
        openCardFollow: this.ruleForm.openCardFollow,
        firstOpenCardTimeType: this.ruleForm.firstOpenCardTimeType,
        openCardBeforeDay: this.ruleForm.openCardBeforeDay,
        isForceRemind: this.isForceRemind,
        ...this.bargainConfig,
        bargainGood: this.specifytList[0],

        //积分竞拍
        ticket: this.ruleForm.ticket, 
        startPrice: this.ruleForm.startPrice, 
        addPrice: this.ruleForm.addPrice,
        auctionStartTime: this.auctionTimeValue[0], 
        auctionEndTime: this.auctionTimeValue[1], 
        dealRuleType: this.ruleForm.dealRuleType, 
        dealTargetPrice: this.ruleForm.dealTargetPrice, 
        payTime: this.ruleForm.payTime, 
        payTimeUnit: this.ruleForm.payTimeUnit,
        isReservedAddress: this.ruleForm.isReservedAddress, // 是否预留收货地址
      };
      let obj = {
        ...this.ruleForm,
        subType: 70,
        ruleDTO,
        pointActivityPrizeDTOList: [],
        isKeyActivity: this.isKeyActivity,
        placementPosition: this.placementPosition.join(","),
      };
      // 直接从 tableData 过滤，不需要依赖 itemArr
      let list = this.tableData.filter((item) => item.prizeType > 0);
      obj.pointActivityPrizeDTOList = list;
      obj.condFollow = Number(this.ruleForm.condFollow);
      obj.ruleDTO.openCardStartTime =
        this.actMember == 2 ? this.ruleDTO.openCardStartTime : "";
      obj.ruleDTO.openCardEndTime =
        this.actMember == 2 ? this.ruleDTO.openCardEndTime : "";
      obj.ruleDTO.plusObject = this.ruleDTO.plusObject;
      // 其他活动页配置
      obj.ruleDTO.customerPaperwork = JSON.stringify(this.customerPaperwork);

      //曝光商品集合设置
      // obj.priceType = 0;
      // obj.isExposureItem = this.ruleForm.isExposureItem ? 1 : 0;
      // obj.itemList = this.itemListFor;

      // 模板
      obj.templateJson = this.templateJson;
      obj.templateId = this.templateId;

      // 活动对象处理
      // 参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
      obj.allowLevel =
        this.ruleForm.partner && this.ruleForm.partner.length
          ? this.ruleForm.partner.join(",")
          : "";

      if (this.actMember == 1) {
        obj.allowLevel = "-1";
      } else if (this.actMember == 3) {
        obj.allowLevel = "99";
        obj.crowdIds = this.peopleSelected.join(",");
      } else if (this.actMember == 2) {
        obj.allowLevel =
          this.ruleForm.partner && this.ruleForm.partner.length
            ? this.ruleForm.partner.join(",")
            : "";
        if (obj.allowLevel == "-1") {
          //会员等级设置
          let list = ["-1", "0"];
          this.levelList.forEach((item, index) => {
            let num = index + 1;
            list.push(num);
          });
          obj.allowLevel = list.join(",");
        }
      }
      // obj.ruleDTO.cusType = this.actMember == 2 ? this.ruleDTO.cusType : 0;
      obj.ruleDTO.orderCompleteLimitCount =
        this.ruleForm.orderCompleteLimitCount;
      obj.ruleDTO.orderCompleteMaxCount = this.ruleForm.orderCompleteMaxCount;
      obj.ruleDTO.orderCompleteLimitPayment =
        this.ruleForm.orderCompleteLimitPayment;
      obj.ruleDTO.orderCompleteMaxPayment =
        this.ruleForm.orderCompleteMaxPayment;
      obj.ruleDTO.lastOrderCompleteTimeType =
        this.ruleForm.lastOrderCompleteTimeType;
      if (obj.ruleDTO.lastOrderCompleteTimeType == 1) {
        obj.ruleDTO.lastOrderCompleteStartDay =
          this.ruleForm.lastOrderCompleteStartDay;
        obj.ruleDTO.lastOrderCompleteEndDay =
          this.ruleForm.lastOrderCompleteEndDay;
      } else if (obj.ruleDTO.lastOrderCompleteTimeType == 2) {
        obj.ruleDTO.lastOrderCompleteStartTime =
          this.ruleForm.lastOrderCompleteStartTime;
        obj.ruleDTO.lastOrderCompleteEndTime =
          this.ruleForm.lastOrderCompleteEndTime;
      }
      delete obj.partner;
      delete obj.openCardFollow;
      delete obj.firstOpenCardTimeType;
      delete obj.openCardBeforeDay;
      delete obj.orderCompleteLimitCount;
      delete obj.orderCompleteMaxCount;
      delete obj.orderCompleteLimitPayment;
      delete obj.orderCompleteMaxPayment;
      delete obj.lastOrderCompleteTimeType;
      delete obj.lastOrderCompleteStartDay;
      delete obj.lastOrderCompleteEndDay;
      delete obj.lastOrderCompleteStartTime;
      delete obj.lastOrderCompleteEndTime;
      if (this.checked == true || this.isDraft) {
        this.saveLoading = true;
        if (this.activityData.isStart) {
          let params = {
            activityId: this.valueRow.id,
            ruleDescription: obj.ruleDescription,
            prizes: this.prizeList.map((item) => {
              return {
                ...item,
                prizeId: item.id,
                title: item.title,
              };
            }),
            // isExposureItem: this.ruleForm.isExposureItem ? 1 : 0, //曝光商品
            itemList: this.ruleForm.isExposureItem ? this.itemListFor : [],
            activityName: obj.activityName,
            condFollow: obj.condFollow ? 1 : 0,
            ruleDto: obj.ruleDTO,
            templateId: this.templateId,
            endTime: this.ruleForm.endTime,
          };
          updateCommon(params)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                this.joinBlackList = false;
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
                this.$message.success("修改成功");
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
               this.saveLoading = false;
            });
        } else {
          if (this.isDraft) {
            obj.status = 5;
            delete obj.templateJson;
          } else {
            // 保存正式活动不需要status
            if (obj.status) delete obj.status;
            if (!this.activityData.isCopy) {
              // 未开始活动修改
              if (this.valueRow && this.valueRow.id) {
                obj.pointActivityId = this.valueRow.id;
                obj.id = this.valueRow.id;
              }
            } else {
              delete obj.templateJson;
            }
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id;
            // 草稿箱不需要传 pointActivityId
            if (obj.pointActivityId) delete obj.pointActivityId;
          }
          pointAuctions(obj)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                if (this.isDraft) {
                  this.$message.success("保存成功！");
                  this.$emit("returnBack", true);
                } else {
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
               this.saveLoading = false;
            });
        }
      } else {
        this.saveLoading = false;
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      
      if (this.valueRow && this.valueRow.id) {
        if (this.activityData.isStart) {
          this.bargainInfo.splice(this.bargainInfo.length - 1, 0, {
            label: "剩余库存",
            slot: "remanentAmountSlot",
            minWidth: 180,
          });
          this.inviteInfo.splice(this.inviteInfo.length - 1, 0, {
            label: "剩余库存",
            slot: "remanentAmountSlot",
            minWidth: 180,
          });
          this.bargainInfo.some((item) => {
            if (item.slot == "actionSlot") {
              item.minWidth = 300;
              return true;
            }
          });
          this.inviteInfo.some((item) => {
            if (item.slot == "actionSlot") {
              item.minWidth = 300;
              return true;
            }
          });
        }
        this.loading = true;
        getActivityDetailCommon(this.valueRow.id)
          .then((res) => {
            const {
              activityName,
              startTime,
              endTime,
              ruleDto,
              isExposureItem,
              ruleDescription,
              allowLevel,
              crowdIds,
              condFollow,
              templateId,
              pointActivityPrizeDTOList,
              isKeyActivity,
              placementPosition,
            } = res.data;
            const {
              openCardFollow,
              firstOpenCardTimeType,
              openCardBeforeDay,
              isForceRemind,
              //积分竞拍
              ticket,
              startPrice,
              addPrice,
              auctionStartTime,
              auctionEndTime,
              dealRuleType,
              dealTargetPrice,
              payTime,
              payTimeUnit,
              isReservedAddress
            } = ruleDto;
            this.ruleForm.activityName =
              activityName + (this.activityData.isCopy ? "复制" : "");

            this.ruleForm.condFollow = condFollow ? true : false;
            // 活动对象配置
            if (allowLevel == "99") {
              this.peopleSelected = crowdIds.split(",");
              this.actMember = "3";
            } else if (allowLevel == "-1") {
              this.actMember = "1";
              this.ruleForm.partner = ["-1"];
            } else {
              this.actMember = "2";
              if (allowLevel.indexOf("-1") != -1) {
                this.ruleForm.partner = ["-1"];
              } else {
                this.ruleForm.partner = allowLevel.split(",");
              }
            }
            this.ruleForm.openCardFollow = openCardFollow;
            this.ruleForm.firstOpenCardTimeType = firstOpenCardTimeType;
            this.ruleForm.openCardBeforeDay = openCardBeforeDay;
            this.ruleDTO = ruleDto;
            // if (this.ruleDTO.cusType != 0) {
            //   this.actMember = "2";
            // }
            this.isForceRemind = isForceRemind;
            this.isKeyActivity = isKeyActivity;
            this.placementPosition = placementPosition ? placementPosition.split(",") : ["SHOP"];
            this.ruleForm.orderCompleteLimitCount =
              ruleDto.orderCompleteLimitCount;
            this.ruleForm.orderCompleteMaxCount = ruleDto.orderCompleteMaxCount;
            this.ruleForm.orderCompleteLimitPayment =
              ruleDto.orderCompleteLimitPayment;
            this.ruleForm.orderCompleteMaxPayment =
              ruleDto.orderCompleteMaxPayment;
            this.ruleForm.lastOrderCompleteTimeType =
              ruleDto.lastOrderCompleteTimeType || 0;
            this.ruleForm.lastOrderCompleteStartDay =
              ruleDto.lastOrderCompleteStartDay;
            this.ruleForm.lastOrderCompleteEndDay =
              ruleDto.lastOrderCompleteEndDay;
            this.ruleForm.lastOrderCompleteStartTime =
              ruleDto.lastOrderCompleteStartTime;
            this.ruleForm.lastOrderCompleteEndTime =
              ruleDto.lastOrderCompleteEndTime;
            
            //积分竞拍回显
            this.ruleForm.ticket = ticket;
            this.ruleForm.startPrice = startPrice;
            this.ruleForm.addPrice = addPrice;
            this.ruleForm.auctionStartTime = auctionStartTime;
            this.ruleForm.auctionEndTime = auctionEndTime;
            this.ruleForm.dealRuleType = dealRuleType;
            this.ruleForm.dealTargetPrice = dealTargetPrice;
            this.ruleForm.payTime = payTime;
            this.ruleForm.payTimeUnit = payTimeUnit;
            this.ruleForm.isReservedAddress = isReservedAddress || false; // 是否预留收货地址
            //竞拍时间回显
            this.auctionTimeValue = [auctionStartTime || '', auctionEndTime || ''];

            // 指定商品回显
            this.specifytList = [ruleDto.bargainGood];
            this.showSelectGoods = [ruleDto.bargainGood];
            // 砍价配置回显
            const {
              bargainType,
              firstBargainAmountUpperLimit,
              firstBargainAmountLowerLimit,
              newMemberBargainAmountUpperLimit,
              newMemberBargainAmountLowerLimit,
              oldMemberBargainAmountUpperLimit,
              oldMemberBargainAmountLowerLimit,
              inviteLimitType,
            } = ruleDto;
            this.bargainConfig.bargainType = bargainType;
            this.bargainConfig.firstBargainAmountUpperLimit =
              firstBargainAmountUpperLimit;
            this.bargainConfig.firstBargainAmountLowerLimit =
              firstBargainAmountLowerLimit;
            this.bargainConfig.newMemberBargainAmountUpperLimit =
              newMemberBargainAmountUpperLimit;
            this.bargainConfig.newMemberBargainAmountLowerLimit =
              newMemberBargainAmountLowerLimit;
            this.bargainConfig.oldMemberBargainAmountUpperLimit =
              oldMemberBargainAmountUpperLimit;
            this.bargainConfig.oldMemberBargainAmountLowerLimit =
              oldMemberBargainAmountLowerLimit;
            this.bargainConfig.inviteLimitType = inviteLimitType;

            //奖品回显
            this.prizeList =
              pointActivityPrizeDTOList && pointActivityPrizeDTOList.length
                ? pointActivityPrizeDTOList
                : [
                    {
                      assetsId: null, // 资产项id(计划id优惠卷id商品id)
                      prizeType: 0,
                      price: null,
                      logo: null,
                      title: "",
                      totalAmount: null,
                      reducePrice: null, // 减价
                      successInviteNum: null, // 成功邀请人数
                    },
                    {
                      assetsId: null, // 资产项id(计划id优惠卷id商品id)
                      prizeType: 0,
                      price: null,
                      logo: null,
                      title: "",
                      totalAmount: null,
                      reducePrice: null, // 减价
                      successInviteNum: null, // 成功邀请人数
                    },
                  ];
            
            // tableData 回显
            this.tableData =
              pointActivityPrizeDTOList && pointActivityPrizeDTOList.length
                ? pointActivityPrizeDTOList
                : [
                    {
                      sort: 0,
                      assetsId: null, // 资产项id(计划id优惠卷id商品id)
                      prizeType: 0,
                      price: null,
                      logo: null,
                      title: "",
                      totalAmount: null,
                    },
                  ];
            if (ruleDto.customerPaperwork) {
              this.customerPaperwork = JSON.parse(ruleDto.customerPaperwork);
              this.$set(this.customerPaperwork, 'shopNameType', this.customerPaperwork.shopNameType || 0);
            }
            this.templateId = templateId;
            this.getPolite();
            this.loading = false;
            // v2.5 => 复制不需要回显奖品和规则
            if (!this.activityData.isCopy) {
              this.ruleForm.startTime = startTime;
              this.ruleForm.endTime = endTime;
              this.activityStartTime = startTime;
              this.activityEndTime = endTime;

              this.ruleForm.isExposureItem = isExposureItem ? true : false;
              this.itemListFor = res.data.itemList;
              this.ruleForm.ruleDescription = ruleDescription;
            }
            this.templateJson = JSON.parse(res.data.templateJson);
            if (this.activityData.isCopy) {
              this.prizeList = [
                {
                  assetsId: null, // 资产项id(计划id优惠卷id商品id)
                  prizeType: 0,
                  price: null,
                  logo: null,
                  title: "",
                  totalAmount: null,
                  reducePrice: null, // 减价
                  successInviteNum: null, // 成功邀请人数
                },
                {
                  assetsId: null, // 资产项id(计划id优惠卷id商品id)
                  prizeType: 0,
                  price: null,
                  logo: null,
                  title: "",
                  totalAmount: null,
                  reducePrice: null, // 减价
                  successInviteNum: null, // 成功邀请人数
                },
              ];
              // 复制时重置 tableData
              this.tableData = [
                {
                  sort: 0,
                  assetsId: null, // 资产项id(计划id优惠卷id商品id)
                  prizeType: 0,
                  price: null,
                  logo: null,
                  title: "",
                  totalAmount: null,
                },
              ];
              this.ruleForm.ruleDescription = "";
            }
            console.log(this.prizeList, "gfgfg");
          })
          .catch((res) => {});
      } else {
        this.activityStartTime = this.$getDate(30)[0];
        this.activityEndTime = this.$getDate(30)[1];
        this.hdTaskTemplateGroup();
      }
    },
    clickLocalStep() {
      if (this.activityData.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.localStepNum = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 28px 28px 1px 24px;
    margin-bottom: 29px;
  }
  .buttonGroup {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #666;
  }

  .invite-box {
    background-color: #f7f8fa;
    padding: 16px;
    border-radius: 8px;
  }

  .ml12 {
    margin-left: 12px;
  }

  .ml8 {
    margin-left: 8px;
  }

  .ml20 {
    margin-left: 20px;
  }

  .mlr8 {
    margin: 0 8px;
  }

  .w90 {
    width: 90px;
  }
  .w125 {
    width: 125px;
  }
  .w150 {
    width: 150px;
  }
  .w180 {
    width: 180px;
  }

  .tip-color {
    color: #666;
  }

  .logo-style {
    margin-top: 8px;
    width: 80px;
    height: 80px;
  }

  .text-red {
    color: #ff4d4f;
  }
}
.buttonGroupUI {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #666;
  .color-style {
    color: #999999;
    font-size: 14px;
    margin-left: 12px;
  }
}
.flex-sc {
  display: flex;
}
.set-left {
  flex: 1;
}
.bg-box {
  width: 40%;
  display: block;
}
.pdb20 {
  padding-bottom: 20px;
}
</style>
